import React from 'react';
import {Route, Routes} from "react-router-dom";
import ClientCreateEdit from "./ClientCreateEdit";
import ClientList from "./ClientList";


function ClientsRouter() {

    return (
        <Routes>
            <Route path="" element={<ClientList/>}/>
            <Route path="/:id/edit" element={<ClientCreateEdit/>}/>
            <Route path="/new" element={<ClientCreateEdit/>}/>

        </Routes>
    )
}


export default function Clients() {
    return (
        <ClientsRouter/>
    )
}
